export default String.raw`
{% if include contains '|' and include contains 'company' -%}
	{% assign company = true -%}
	{% assign chosenType = config.Registration.Company -%}
	{% assign addressVisible = chosenType.AddressVisible -%}
	{% assign addressRequired = chosenType.AddressRequired -%}
	{% assign phoneVisible = chosenType.phoneVisible -%}
	{% assign phoneRequired = chosenType.phoneRequired -%}

	{% assign includeArr = include | Split:'|' -%}
    {% assign countryISOCode = includeArr[0] -%}
{% elsif include == 'retail' or include == 'company' -%}
	{% if include == 'company' -%}
		{% assign chosenType = config.Registration.Company -%}
		{% assign company = true -%}
	{% else -%}
		{% assign chosenType = config.Registration.Retail -%}
	{% endif -%}
	{% assign addressVisible = chosenType.AddressVisible -%}
	{% assign addressRequired = chosenType.AddressRequired -%}
	{% assign phoneVisible = chosenType.phoneVisible -%}
	{% assign phoneRequired = chosenType.phoneRequired -%}
{% else -%}
	{% if customer.Company -%}
		{% assign company = true -%}
	{% endif -%}
	{% assign addressVisible = true -%}
	{% assign addressRequired = true -%}
	{% assign phoneVisible = true -%}
	{% assign phoneRequired = true -%}
{% endif -%}

{% assign cityRequired = config.Countries[countryISOCode].RequiredFields.City -%}
{% assign streetRequired = config.Countries[countryISOCode].RequiredFields.Street -%}
{% assign streetNoRequired = config.Countries[countryISOCode].RequiredFields.StreetNo -%}
{% assign zipCodeRequired = config.Countries[countryISOCode].RequiredFields.ZipCode -%}
{% assign TINRequired = config.Countries[countryISOCode].RequiredFields.TIN -%}

{% if customer.Company or company -%}
	{% assign TINRequired = true -%}
{% else -%}
	{% assign TINRequired = false -%}
{% endif -%}

{% unless countryISOCode -%}
    {% assign countryISOCode = config.Countries[0].ISOCode -%}
{% endunless -%}

{% if addressVisible -%}
	<div class="{% if company -%} company-form-js {% else -%} retail-form-js {% endif -%}">
	{% if company -%}
		{% if config.ENTERPRISE -%}
			{% for v in config.VATEU -%}
				{% if v.ISOCode == countryISOCode -%}
					{% assign vateuExists = true -%}
					{% break -%}
				{% endif -%}
			{% endfor -%}
			{% if vateuExists -%}
		<div class="reg-container__input-wrappers-city">
			<div class="form__input-wrapper">
				<label for="reg-vateu" class="form__input-info input-info-js">{{ translations.CountryCode }}</label>
				<select id="reg-vateu" aria-label="{{ translations.CountryCode }}" name="vateu" class="form__input-value input-value-js reg-container__select registration-tin-js">
					<option value="" label=" "></option>
				{% for v in config.VATEU -%}
					{% if v.ISOCode == countryISOCode -%}
					<option value="{{ v.Value }}">{{ v.Name }}</option>
					{% endif -%}
				{% endfor -%}
				</select>
			</div>
			{% endif -%}
		{% endif -%}
			<div class="form__input-wrapper">
				<label for="tin" class="form__input-info input-info-js">{% if TINRequired %}<span class="required">* </span>{% endif %}{{ translations.TIN }}</label>
				<input id="tin" type="text" name="tin" value="{{ tin }}" class="form__input-value input-value-js" {% if TINRequired -%} required {% endif -%} data-check-sum="{% if countryISOCode == 'PL' -%}true{% else -%}false{% endif -%}" maxlength="20" >
		{% if TINRequired -%}
				<div class="form__invalid-input validation-required-js tin-validation-check-js hidden-js">{{ translations.FillTIN }}</div>
		{% endif -%}
				<div class="form__invalid-input validation-info-js validation-tin-js hidden-js tin-validation-check-js">{{ translations.FillProperTIN }}</div>
				<div class="form__invalid-input validation-info-js validation-gus-js hidden-js tin-validation-check-js">{{ translations.NoTINinGUS }}</div>
				<div class="form__invalid-input validation-info-js validation-gus-allow-when-not-responding-js hidden-js tin-validation-check-js">{{ translations.GUSErrorFillData }}</div>
				<div class="form__invalid-input validation-info-js validation-gus-dont-allow-when-not-responding-js hidden-js tin-validation-check-js">{{ translations.GUSErrorTryLater }}</div>
				<div class="form__invalid-input validation-info-js validation-vies-js hidden-js allow-not-hidden-js tin-validation-check-js">{{ translations.NoTINinVIES }}</div>
				<div class="form__invalid-input validation-info-js validation-vies-allow-when-not-responding-js hidden-js allow-not-hidden-js tin-validation-check-js">{{ translations.VIESErrorFillData }}</div>
				<div class="form__invalid-input validation-info-js validation-vies-dont-allow-when-not-responding-js hidden-js allow-not-hidden-js tin-validation-check-js">{{ translations.VIESErrorTryLater }}</div>
		{% if config.ENTERPRISE and vateuExists -%}
			</div>
		</div>
		{% endif -%}
	{% else -%}
		<div class="form__input-wrapper">
			<label for="name" class="form__input-info input-info-js"><span class="required">* </span>{{ translations.NameAndSurname }}</label>
			<input class="form__input-value input-value-js" id="name" type="text" name="name" value="{{ customer.Address.Name | H }}" maxlength="50" required>
			<div class="form__invalid-input validation-required-js hidden-js">{{ translations.FillNameAndSurname }}</div>
		</div>
		<div class="form__input-wrapper">
			<label for="name2" class="form__input-info input-info-js">{{ translations.NameAndSurname }}</label>
			<input class="form__input-value input-value-js" id="name2" type="text" name="name2" autocomplete="name" value="{{ customer.Address.Name2 | H }}" maxlength="50">
		</div>
	{% endif -%}
	</div>
{% endif -%}
`